import { render, staticRenderFns } from "./EditableBackground.vue?vue&type=template&id=41b65347&scoped=true"
import script from "./EditableBackground.vue?vue&type=script&lang=js"
export * from "./EditableBackground.vue?vue&type=script&lang=js"
import style0 from "./EditableBackground.vue?vue&type=style&index=0&id=41b65347&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b65347",
  null
  
)

export default component.exports